import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/** モジュール */
// ルーティング
import { PagesRoutingModule } from './pages-routing.module';

// 共通
import { SharedModule } from 'src/app//shared/shared.module';
import { LibraryModule } from 'src/app/library/library.module';

/** コンポーネント */
// Platform系統Component基幹
import { PlatformComponent } from './platform/platform.component';
// 会員一覧（A110）
import { A110Component } from './platform/a110/a110.component';
// 入会申請(A201)
// 入会申請確認(A202)
import { A201Component } from './platform/a201/a201.component';
// 入会申請メールアドレス確認
import { A203Component } from './platform/a203/a203.component';
// 入会申請完了
import { A204Component } from './platform/a204/a204.component';
// 入会審査完了後のメールアドレス入力（ＩＤ活性化）
import { A210Component } from './platform/a210/a210.component';
// パスワード設定メール送付完了
import { A211Component } from './platform/a211/a211.component';
// 新規入会時のパスワード設定
import { A212Component } from './platform/a212/a212.component';
// 新規入会時のパスワード設定完了
import { A213Component } from './platform/a213/a213.component';
// 入会申請詳細
import { A231Component } from './platform/a231/a231.component';
// 自治体会員登録・更新画面(入力)(B101)
// 自治体会員登録・更新画面(確認画面)(B102)
import { B101Component } from './platform/b101/b101.component';
// 自治体会員登録・更新画面（登録・更新完了）(B103)
import { B103Component } from './platform/b103/b103.component';
// ユーザー一覧(B220)
import { B220Component } from './platform/b220/b220.component';
// ユーザー登録(B221)
import { B221Component } from './platform/b221/b221.component';
// ユーザー登録完了(B223)
import { B223Component } from './platform/b223/b223.component';
// 会員プロフィール(自治体)
import { B211Component } from './platform/b211/b211.component';
// 会員プロフィール(民間団体)
import { B212Component } from './platform/b212/b212.component';
// マイページ
import { B301Component } from './platform/b301/b301.component';
// 課題・ソリューション登録(C101)
// 課題・ソリューション登録確認(C102)
import { C101Component } from './platform/c101/c101.component';
// 課題・ソリューション登録完了
import { C103Component } from './platform/c103/c103.component';
// 課題・ソリューション登録・管理
import { C104Component } from './platform/c104/c104.component';
// 課題・ソリューション一覧
import { C201Component } from './platform/c201/c201.component';
// 課題・ソリューション詳細
import { C301Component } from './platform/c301/c301.component';
// 提案登録(C401)
// 提案登録確認(C402)
import { C401Component } from './platform/c401/c401.component';
// マッチング提案登録完了
import { C403Component } from './platform/c403/c403.component';
// マッチング依頼一覧
import { C502Component } from './platform/c502/c502.component';
// 提案詳細
import { C601Component } from './platform/c601/c601.component';
// 事務局メニュー
import { D101Component } from './platform/d101/d101.component';
// 会員入会審査
import { D211Component } from './platform/secretariat-list/d211/d211.component';
// 会員更新審査
import { D212Component } from './platform/secretariat-list/d212/d212.component';
// 課題・ソリューション審査
import { D221Component } from './platform/secretariat-list/d221/d221.component';
// 提案審査
import { D231Component } from './platform/secretariat-list/d231/d231.component';
// 会員主催イベント審査
import { D241Component } from './platform/secretariat-list/d241/d241.component';
// 分科会審査
import { D251Component } from './platform/secretariat-list/d251/d251.component';
// 問い合わせ一覧
import { D261Component } from './platform/secretariat-list/d261/d261.component';
// 問い合わせ詳細
import { D262Component } from './platform/d262/d262.component';
// 掲示板コメント（D271）審査
import { D271Component } from './platform/secretariat-list/d271/d271.component';
// 連携事例（D281）審査
import { D281Component } from './platform/secretariat-list/d281/d281.component';
// 掲示板通報（D291）審査
import { D291Component } from './platform/secretariat-list/d291/d291.component';
// 掲示板通報詳細
import { D292Component } from './platform/d292/d292.component';
// お知らせ一覧(E001)
// PF主催イベント一覧(E002)
// 会員主催イベント一覧(E101)
import { E001Component } from './platform/e001/e001.component';
// 会員主催イベント詳細(E102)
import { E102Component } from './platform/e102/e102.component';
// 会員主催イベント申請一覧(E103)
import { E103Component } from './platform/e103/e103.component';
// 会員主催イベント申請登録(E104)
// 会員主催イベント申請登録確認E105)
import { E104Component } from './platform/e104/e104.component';
// 会員主催イベント申請登録完了(E106)
import { E106Component } from './platform/e106/e106.component';
// 分科会一覧
import { E201Component } from './platform/e201/e201.component';
// 分科会詳細
import { E202Component } from './platform/e202/e202.component';
// 分科会申請一覧
import { E203Component } from './platform/e203/e203.component';
// 分科会申請登録(E204)
// 分科会申請登録確認(E205)
import { E204Component } from './platform/e204/e204.component';
// 分科会申請登録完了
import { E206Component } from './platform/e206/e206.component';
// 問い合わせ登録(E301)
// 問い合わせ登録確認(E302)
import { E301Component } from './platform/e301/e301.component';
// 問い合わせ登録完了
import { E303Component } from './platform/e303/e303.component';
// 分科会参加登録
import { E401Component } from './platform/e401/e401.component';
// 分科会参加登録完了
import { E403Component } from './platform/e403/e403.component';
// 会員一覧・CSVダウンロード
import { F111Component } from './platform/master/f111/f111.component';
// 課題・ソリューション一覧・CSVダウンロード
import { F121Component } from './platform/master/f121/f121.component';
// 提案一覧・CSVダウンロード
import { F131Component } from './platform/master/f131/f131.component';
// 会員主催イベント一覧・CSVダウンロード
import { F141Component } from './platform/master/f141/f141.component';
// 分科会一覧・CSVダウンロード
import { F151Component } from './platform/master/f151/f151.component';
// 分科会参加者一覧
import { F171Component } from './platform/master/f171/f171.component';
// お知らせ一覧
import { G101Component } from './platform/g101/g101.component';
// お知らせ詳細
import { G102Component } from './platform/g102/g102.component';
// お知らせ登録(G103)
// お知らせ登録確認(G104)
import { G103Component } from './platform/g103/g103.component';
// お知らせ登録完了
import { G105Component } from './platform/g105/g105.component';
// 連携事例登録
import { H101Component } from './platform/h101/h101.component';
// 連携事例登録完了
import { H103Component } from './platform/h103/h103.component';
// 連携事例管理
import { H104Component } from './platform/h104/h104.component';
// 連携事例一覧
import { H201Component } from './platform/h201/h201.component';
// 連携事例詳細
import { H301Component } from './platform/h301/h301.component';
// ダッシュボード(I100)
// ダッシュボード(I101)
import { I101Component } from './platform/i101/i101.component';
// 事例紹介記事一覧(J101)
import { J101Component } from './platform/j101/j101.component';
import { J201Component } from './platform/j201/j201.component';
import { J202Component } from './platform/j202/j202.component';
import { J203Component } from './platform/j203/j203.component';
import { J205Component } from './platform/j205/j205.component';
// 入会申請修正(K101)
// 入会申請修正確認(K102)
import { K101Component } from './platform/k101/k101.component';
// 入会申請修正完了(K103)
import { K103Component } from './platform/k103/k103.component';
import { K104Component } from './platform/k104/k104.component';
// 掲示板スレッド一覧
import { L101Component } from './platform/l101/l101.component';
// 掲示板スレッド閲覧
import { L201Component } from './platform/l201/l201.component';
import { L301Component } from './platform/l301/l301.component';

// 共通部品
import { ApprovalDialogComponent } from './platform/common/approval-dialog/approval-dialog.component';
import { ReportDialogComponent } from './platform/common/report-dialog/report-dialog.component';
import { ChatComponent } from './platform/common/chat/chat.component';
import { PostalNoDialogComponent } from './platform/common/postal-no-dialog/postal-no-dialog.component';
import { DiffTableComponent } from './platform/common/diff-table/diff-table.component';
import { SubcommitteeDialogComponent } from './platform/common/subcommittee-dialog/subcommittee-dialog.component';
// A200共通部品
import { A200StepsComponent } from './platform/a200-common/a200-steps/a200-steps.component';
import { A210StepsComponent } from './platform/a200-common/a210-steps/a210-steps.component';
import { A220StepsComponent } from './platform/a200-common/a220-steps/a220-steps.component';
import { A230StepsComponent } from './platform/a200-common/a230-steps/a230-steps.component';
// B100共通部品
import { B100StepsComponent } from './platform/b100-common/b100-steps/b100-steps.component';
// C100共通部品
import { C100StepsComponent } from './platform/c100-common/c100-steps/c100-steps.component';
// C400共通部品
import { C400StepsComponent } from './platform/c400-common/c400-steps/c400-steps.component';
// E200共通部品
import { E200StepsComponent } from './platform/e200-common/e200-steps/e200-steps.component';
// B220共通部品
import { B220StepsComponent } from './platform/b200-common/b220-steps/b220-steps.component';
// E100共通部品
import { E100StepsComponent } from './platform/e100-common/e100-steps/e100-steps.component';
// E300共通部品
import { E300StepsComponent } from './platform/e300-common/e300-steps/e300-steps.component';
// G100共通部品
import { G100StepsComponent } from './platform/g100-common/g100-steps/g100-steps.component';
// K100共通部品
import { K100StepsComponent } from './platform/k100-common/k100-steps/k100-steps.component';
// // H100共通部品
// import { H100StepsComponent } from './platform/h100-common/h100-steps/h100-steps.component';
// J200共通部品
import { J200StepsComponent } from './platform/j200-common/j200-steps/j200-steps.component';
// L300共通部品
import { L300StepsComponent } from './platform/l300-common/l300-steps/l300-steps.component';

// ログアウト
import { LogoutComponent } from './logout/logout.component';
import { FollowDialogComponent } from './platform/common/follow-dialog/follow-dialog.component';
import { ConfirmQuotationDialogComponent } from './platform/common/confirm-quotation-dialog/confirm-quotation-dialog.component';
import { ConfirmRequestMoreDetailsDialogComponent } from './platform/common/confirm-request-more-details-dialog/confirm-request-more-details-dialog.component';
import { IssueDetailDialogComponent } from './platform/common/issue-detail-dialog/issue-detail-dialog.component';
import { MemberDetailDialogComponent } from './platform/common/member-detail-dialog/member-detail-dialog.component';
import {PaginatorModule} from 'primeng/paginator';
@NgModule({
  declarations: [
    // Platform系統Component基幹
    PlatformComponent,
    // 会員一覧(A110)
    A110Component,
    // 入会申請(A201)
    // 入会申請確認(A202)
    A201Component,
    // 入会申請メールアドレス確認
    A203Component,
    // 入会申請完了
    A204Component,
    // 入会審査完了後のメールアドレス入力（ＩＤ活性化）
    A210Component,
    // パスワード設定メール送付完了
    A211Component,
    // 新規入会時のパスワード設定
    A212Component,
    // 新規入会時のパスワード設定完了
    A213Component,
    // 入会申請詳細
    A231Component,
    // 自治体会員登録・更新画面(入力)(B101)
    // 自治体会員登録・更新画面(確認画面)(B102)
    B101Component,
    // 自治体会員登録・更新画面（登録・更新完了）(B103)
    B103Component,
    // ユーザー一覧(B220)
    B220Component,
    // ユーザー登録(B221)
    B221Component,
    // ユーザー登録完了(B223)
    B223Component,
    // 会員プロフィール(自治体)
    B211Component,
    // 会員プロフィール(民間団体)
    B212Component,
    // マイページ
    B301Component,
    // 課題・ソリューション登録(C101)
    // 課題・ソリューション登録確認(C102)
    C101Component,
    // 課題・ソリューション登録完了
    C103Component,
    // 課題・ソリューション登録・管理
    C104Component,
    // 課題・ソリューション一覧
    C201Component,
    // 課題・ソリューション詳細
    C301Component,
    // 提案登録(C401)
    // 提案登録確認(C402)
    C401Component,
    // マッチング提案登録完了
    C403Component,
    // マッチング依頼一覧
    C502Component,
    // 提案詳細
    C601Component,
    // 事務局メニュー
    D101Component,
    // お知らせ一覧(E001)
    // PF主催イベント一覧(E002)
    // 会員主催イベント一覧(E101)
    // 入会審査
    D211Component,
    // 会員更新審査
    D212Component,
    // 課題・ソリューション審査
    D221Component,
    // 提案審査
    D231Component,
    // 会員主催イベント審査
    D241Component,
    // 分科会審査
    D251Component,
    // 問い合わせ一覧
    D261Component,
    // 問い合わせ詳細
    D262Component,
    // 掲示板コメント（D271）審査
    D271Component,
    // 連携事例（D281）審査
    D281Component,
    // 掲示板通報（D291）審査
    D291Component,
    // 掲示板通報（D292）審査
    D292Component,
    // お知らせ一覧(E001)
    // PF主催イベント一覧(E002)
    // 会員主催イベント一覧(E101)
    E001Component,
    // 会員主催イベント詳細
    E102Component,
    // 会員主催イベント申請一覧
    E103Component,
    // 会員主催イベント申請登録(E104)
    // 会員主催イベント申請登録確認E105)
    E104Component,
    // 会員主催イベント申請登録完了(E106)
    E106Component,
    // 分科会一覧
    E201Component,
    // 分科会詳細
    E202Component,
    // 分科会申請一覧
    E203Component,
    // 分科会申請登録(E204)
    // 分科会申請登録確認(E205)
    E204Component,
    // 分科会申請登録完了
    E206Component,
    // 問い合わせ登録(E301)
    // 問い合わせ登録確認(E302)
    E301Component,
    // 問い合わせ登録完了
    E303Component,
    // 分科会参加登録
    E401Component,
    // 分科会参加登録完了
    E403Component,
    // 会員一覧・CSVダウンロード
    F111Component,
    // 課題・ソリューション一覧・CSVダウンロード
    F121Component,
    // 提案一覧・CSVダウンロード
    F131Component,
    // 会員主催イベント一覧・CSVダウンロード
    F141Component,
    // 分科会一覧・CSVダウンロード
    F151Component,
    // 分科会参加者一覧
    F171Component,
    // 連携事例登録
    H101Component,
    // 連携事例登録完了
    H103Component,
    // 連携事例一覧(登録・管理)
    H104Component,
    // 連携事例一覧
    H201Component,
    // 連携事例詳細
    H301Component,
    // ダッシュボード
    I101Component,
    // 事例紹介記事一覧
    J101Component,
    // 事例紹介記事一覧
    J201Component,
    // 事例紹介記事詳細
    J202Component,
    // 事例紹介記事登録
    J203Component,
    // 事例紹介記事登録完了
    J205Component,
    // 入会申請修正(K101)
    // 入会申請修正確認(K102)
    K101Component,
    // 入会申請修正完了(K103)
    K103Component,
    // 入会申請修正完了(K104)
    K104Component,
    // 掲示板スレッド一覧
    L101Component,
    // 掲示板スレッド閲覧
    L201Component,
    // 掲示板スレッド登録
    L301Component,
    // 共通部品
    ApprovalDialogComponent,
    ReportDialogComponent,
    ChatComponent,
    PostalNoDialogComponent,
    DiffTableComponent,
    SubcommitteeDialogComponent,
    // A200共通部品
    A200StepsComponent,
    A210StepsComponent,
    A220StepsComponent,
    A230StepsComponent,
    // B100共通部品
    B100StepsComponent,
    // B220共通部品
    B220StepsComponent,
    // C100共通部品
    C100StepsComponent,
    // C400共通部品
    C400StepsComponent,
    // E100共通部品
    E100StepsComponent,
    // E200共通部品
    E200StepsComponent,
    // E300共通部品
    E300StepsComponent,
    // E300共通部品
    K100StepsComponent,
    // // H100共通部品
    // H100StepsComponent,
    // ログアウト
    LogoutComponent,
    G101Component,
    G102Component,
    G103Component,
    G105Component,
    G100StepsComponent,
    J200StepsComponent,
    L300StepsComponent,
    FollowDialogComponent,
    ConfirmQuotationDialogComponent,
    ConfirmRequestMoreDetailsDialogComponent,
    IssueDetailDialogComponent,
    MemberDetailDialogComponent,
  ],
  imports: [CommonModule, PagesRoutingModule, SharedModule, LibraryModule, PaginatorModule],
})
export class PagesModule { }
